import { CouchUserInfo } from "./data-model/couch-user";

// Tolerance for the expiresDate_utc compare in `comparePayProToCouch`:
// 1 hour. Absorbs DST edges, admin/PayPro clock skew around renewal, and
// ISO timezone-format noise (UTC `Z` vs `+00:00` vs vendor-local `+02:00`)
// while still flagging real drift (days to weeks). Lives in shared/ so
// the tools-side verifier (`tools/src/verify-free-days-*-shared.ts`)
// imports the single source of truth instead of hardcoding a redundant copy.
export const kExpiresDateSyncToleranceMs = 60 * 60 * 1000;

// one item of difference for when paypro subscription is different from couchdb
export interface PayProSubscriptionDifference {
  // name of the member
  member: string;
  // our value
  ours: string;
  // their value
  paypro: string;
}

export type PayProSubscriptionSyncInfoIdentical = {
  identical: true;
};

export type PayProSubscriptionSyncInfoDifferent = {
  identical: false;
  expected: Partial<CouchUserInfo>;
  differences: PayProSubscriptionDifference[];
};

export type PayProSubscriptionSyncInfo = PayProSubscriptionSyncInfoIdentical | PayProSubscriptionSyncInfoDifferent;
export function isPayProSubscriptionSyncInfoIdentical(info: PayProSubscriptionSyncInfo): info is PayProSubscriptionSyncInfoIdentical {
  return info.identical;
}
